import { render, staticRenderFns } from "./CustomerListSideMenu.vue?vue&type=template&id=6bb7bcce&scoped=true"
import script from "./CustomerListSideMenu.vue?vue&type=script&lang=js"
export * from "./CustomerListSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb7bcce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bb7bcce')) {
      api.createRecord('6bb7bcce', component.options)
    } else {
      api.reload('6bb7bcce', component.options)
    }
    module.hot.accept("./CustomerListSideMenu.vue?vue&type=template&id=6bb7bcce&scoped=true", function () {
      api.rerender('6bb7bcce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/CustomerListSideMenu.vue"
export default component.exports